var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.isExternal(_vm.link) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.link,
      "exact": _vm.exact
    },
    nativeOn: {
      "focusout": function ($event) {
        return _vm.focusoutAction.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.item.text))]) : _c('a', {
    staticClass: "nav-link external",
    attrs: {
      "href": _vm.link,
      "target": _vm.isMailto(_vm.link) || _vm.isTel(_vm.link) ? null : '_blank',
      "rel": _vm.isMailto(_vm.link) || _vm.isTel(_vm.link) ? null : 'noopener noreferrer'
    },
    on: {
      "focusout": _vm.focusoutAction
    }
  }, [_vm._v("\n  " + _vm._s(_vm.item.text) + "\n  "), _c('OutboundLink')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };